import AddIcon2 from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon2 from "@mui/icons-material/Close";
import DeleteIcon2 from "@mui/icons-material/Delete";
import RefreshIconMUI from "@mui/icons-material/Refresh";
import SaveIcon2 from "@mui/icons-material/Save";
import EditIcon2 from "@mui/icons-material/EditOutlined";
import { RxReset } from "react-icons/rx";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { TbWindowMinimize, TbWindowMaximize } from "react-icons/tb";
import VisibilityIcon2 from "@mui/icons-material/Visibility";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import { SlActionRedo } from "react-icons/sl";
import ProgressCirc from "../layout/Progress/ProgressCirc";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material";
import { Upload } from "@mui/icons-material";
import GroupRemoveIcon from "@mui/icons-material/GroupRemove";
import BoltIcon from "@mui/icons-material/Bolt";
import MergeIcon2 from "@mui/icons-material/Merge";
import CheckIcon2 from "@mui/icons-material/Check";
import RemoveIcon2 from "@mui/icons-material/Remove";

export function TransferIcon(props) {
  return <MoveDownIcon {...props} />;
}

export function ActionIcon(props) {
  return <BoltIcon {...props} />;
}

export function SendIcon(props) {
  const theme = useTheme();
  const { color = null } = props;
  var iconColor = "inherit";
  if (color) iconColor = theme.palette[color].main;

  return (
    <span style={{ color: iconColor }}>
      <SlActionRedo {...props} />
    </span>
  );
}
SendIcon.propTypes = {
  color: PropTypes.string,
};

export function RebootIcon(props) {
  return <RestartAltIcon {...props} />;
}

export function MergeIcon(props) {
  return <MergeIcon2 {...props} />;
}

export function UndoIcon(props) {
  return <RxReset {...props} />;
}
export function MinusIcon(props) {
  return <RemoveIcon2 {...props} />;
}
export function AddIcon(props) {
  return <AddIcon2 {...props} />;
}

export function OKIcon(props) {
  return <CheckIcon2 {...props} />;
}

export function CheckIcon(props) {
  return <CheckIcon2 {...props} />;
}

export function CancelIcon(props) {
  return <ClearIcon {...props} />;
}

export function CloseIcon(props) {
  return <CloseIcon2 {...props} />;
}

export function RemoveIcon(props) {
  return <ClearIcon {...props} />;
}

export function DeleteIcon(props) {
  return <DeleteIcon2 {...props} />;
}
export function DeletePersonIcon(props) {
  return <GroupRemoveIcon color="primary" {...props} />;
}

export function EditIcon(props) {
  return <EditIcon2 {...props} />;
}
export function ViewIcon(props) {
  return <VisibilityIcon2 {...props} />;
}
export function UploadIcon(props) {
  return <Upload {...props} />;
}

export function RefreshIcon({ isLoading, progressProps, ...props }) {
  try {
    return (
      <>
        <RefreshIconMUI
          {...props}
          style={{
            opacity: isLoading ? 0 : 1,
            transition: "opacity 0.3s ease-in-out",
          }}
        />
        <div
          style={{
            position: "absolute",
            opacity: isLoading ? 1 : 0,
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          <ProgressCirc {...progressProps} />
        </div>
      </>
    );
  } catch (e) {
    console.error(e);
    return <RefreshIconMUI />;
  }
}
RefreshIcon.propTypes = {
  isLoading: PropTypes.bool,
  progressProps: PropTypes.object,
};

export function SaveIcon(props) {
  return <SaveIcon2 {...props} />;
}

export function MaximizeIcon(props) {
  return <TbWindowMaximize {...props} />;
}

export function MinimizeIcon(props) {
  return <TbWindowMinimize {...props} />;
}
